//
//
//
//
//
//
//
//

import util from '@/common/js/util'
import WechatUtil from '@/common/js/wechatUtil'
import { GlobalApi } from '@/api'

export default {
  name: 'App',
  created() {
    if (this.$route.name !== 'Authorize') {
      this.initWxConfig()
    }
  },
  methods: {
    initWxConfig() {
      WechatUtil.initWechatConfig(this.$wechat, [
        'scanQRCode',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone',
        'hideAllNonBaseMenuItem',
        'hideMenuItems'
      ])
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue